(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[535],{

/***/ 6484:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workout",
      function () {
        return __webpack_require__(9752);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ WorkoutListPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_layout_PageLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8349);
/* harmony import */ var content_links__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6830);
/* harmony import */ var content_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9930);






var __N_SSG = true;
function WorkoutListPage(param) {
    var workouts = param.workouts;
    var items = workouts.items;
    var og = {
        site_name: content_text__WEBPACK_IMPORTED_MODULE_5__/* .seo.title */ .$K.title,
        title: "Workout - " + content_text__WEBPACK_IMPORTED_MODULE_5__/* .seo.title */ .$K.title,
        description: "Workout plan for Camp Knut",
        url: content_links__WEBPACK_IMPORTED_MODULE_4__/* .baseUrl */ .FH + "/workout"
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout_PageLayout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        widthClassName: "max-w-none",
        openGraph: og,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mx-auto w-11/12",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "text-3xl pb-5 font-bold",
                    children: "Workout Posts"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid auto-rows-max gap-4",
                    style: {
                        gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))"
                    },
                    children: items.map(function(param) {
                        var fields = param.fields;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "/knutReady.webp",
                                    alt: "Workout",
                                    width: 300,
                                    height: 180,
                                    className: "margin-auto flex content-center "
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    passHref: true,
                                    href: "/workout/".concat(fields.slug),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "cursor-pointer",
                                        children: fields.title
                                    })
                                }, fields.slug)
                            ]
                        }, fields.slug);
                    })
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,553,252,774,888,179], function() { return __webpack_exec__(6484); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);